import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import NodeExpandOutlinedSvg from "@ant-design/icons-svg/es/asn/NodeExpandOutlined";
import AntdIcon from "../components/AntdIcon";
var NodeExpandOutlined = function NodeExpandOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: NodeExpandOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  NodeExpandOutlined.displayName = 'NodeExpandOutlined';
}
export default /*#__PURE__*/React.forwardRef(NodeExpandOutlined);